/* tslint:disable */

export const complexStructureFeature = {
  NEW_CONSTRUCTION: 1,
  MONUMENT: 2,
  MUNICIPAL_MONUMENT: 4,
  PROTECTED_CITYSCAPE: 8,
  None: 0,
} as const

export const flaggedBase = {
  None: 0,
} as const

export const searchProfileLocality = {
  MAASTRICHT: 1,
  HEERLEN: 2,
  MEERSSEN: 4,
  SITTARDGELEEN: 8,
  None: 0,
} as const

export const searchProfileObjectType = {
  NON_INDEPENDENT: 1,
  INDEPENDENT: 2,
  None: 0,
} as const

export const subscriberEmailStatus = {
  MATCHMAIL: 1,
  None: 0,
} as const

export const unitOfferAvailability = {
  WEBSITE: 1,
  KIOSK: 2,
  PARARIUS: 4,
  VIEWING_REQUESTS: 32,
  None: 0,
} as const

export const unitOfferDocumentStatus = {
  MADE: 1,
  SENT: 2,
  PROCESSED: 4,
  COLLECTED: 2097152,
  PICKEDUP: 4194304,
  ONHOLD: 16777216,
  None: 0,
} as const

export const unitOfferUtility = {
  GAS: 1,
  WATER: 2,
  ELECTRICITY: 4,
  INTERNET: 8,
  WASHER_LEASE: 16,
  HEATING: 32,
  None: 0,
} as const

export const unitBathroomFeature = {
  SHOWER: 1,
  BATHTUB: 2,
  SINK: 4,
  TOILET_BATHROOM: 8,
  TOILET_SEPARATE: 16,
  None: 0,
} as const

export const unitFacilities = {
  WASHER_CONNECTION_OWN: 1,
  WASHER_CONNECTION_SHARED: 2,
  None: 0,
} as const

export const unitOutdoorSpace = {
  BALCONY: 1,
  COURTYARD_OWN: 2,
  COURTYARD_SHARED: 4,
  ROOFTERRACE_OWN: 8,
  ROOFTERRACE_SHARED: 16,
  GARDEN_OWN: 32,
  GARDEN_SHARED: 64,
  None: 0,
} as const

export const unitParking = {
  PARKING_NOT_AVAILABLE: 1,
  OWN_PARKINGSPOT: 2,
  PARKING_PERMIT: 4,
  PARKING_FOR_RENT: 8,
  PAID_PARKING: 16,
  FREE_PARKING_IN_STREET: 32,
  None: 0,
} as const

export const unitStorageType = {
  BASEMENT: 1,
  SHARED: 2,
  OUTSIDE: 4,
  INSIDE: 8,
  BIKESHED: 16,
  None: 0,
} as const

export const adminDataIntegrityCategory = {
  Rounds: "rounds",
  Offers: "offers",
  Viewings: "viewings",
  Units: "units",
} as const

export const adminNotificationType = {
  SUBSCRIPTION_NEW: "subscription-new",
  SUBSCRIPTION_RENEW: "subscription-renew",
  SUBSCRIPTION_UPGRADE: "subscription-upgrade",
  SUBSCRIPTION_HBM: "subscription-hbm",
  VIEWING_REQUEST: "viewing-request",
  VIEWING_REGISTRATION: "viewing-registration",
  REGISTRATION_ROUND_UNLIMITED_APPLICATION: "registration-round-unlimited-application",
  RENT_WITHOUT_VIEWING_SCHEG: "rent-without-viewing-scheg",
  PARKING_RENT_APPLICATION: "parking-rent-application",
  DATA_INTEGRITY_ISSUES: "data-integrity-issues",
} as const

export const attachmentType = {
  Avatar: "avatar",
  ComplexAttachment: "complex-attachment",
  UnitPhoto: "unit-photo",
  UnitVideo: "unit-video",
  UnitViewingVideo: "unit-viewing-video",
  UnitAttachment: "unit-attachment",
  SubscriberIdentification: "subscriber-identification",
  SubscriberStudyRegistration: "subscriber-studyregistration",
  SubscriberPayslip: "subscriber-payslip",
  SubscriberVisa: "subscriber-visa",
  SubscriberMprExtract: "subscriber-mprextract",
  SubscriberIncomeStatement: "subscriber-incomestatement",
  SubscriberLandlordStatement: "subscriber-landlordstatement",
  AddressStreetview: "address-streetview",
  Generic: "generic",
} as const

export const candidateOrigin = {
  HBM: "hbm",
  HBM_SCHEG: "hbm-scheg",
  RENT_WITHOUT_VIEWING: "rent-without-viewing",
  VIEWING_WITHOUT_REGISTRATION: "viewing-without-registration",
  VIEWING_MANUAL_ADDITION: "viewing-manual-addition",
  SCHEG_RENT_WITHOUT_VIEWING: "scheg-rent-without-viewing",
  PARKING_RENT: "parking-rent",
} as const

export const candidateStatus = {
  PENDING: "pending",
  REVIEW: "review",
  CLOSED: "closed",
} as const

export const changelogSection = {
  ADDED: "added",
  CHANGED: "changed",
  FIXED: "fixed",
  DEPRECATED: "deprecated",
  REMOVED: "removed",
  SECURITY: "security",
} as const

export const commentType = {
  COMMENT: "comment",
  MOTIVATION: "motivation",
  DESCRIPTION: "description",
  COMMUNITY: "community",
  NOTE: "note",
  SYSTEM_NOTE: "system-note",
} as const

export const complexCategory = {
  PARKING: "parking",
  COMMERCIAL: "commercial",
  DOMESTIC: "domestic",
} as const

export const complexManager = {
  HBM: "hbm",
  MAASLAND: "maasland",
  CAMPUS: "campus",
} as const

export const disk = {
  LOCAL: "local",
  PUBLIC: "public",
  S3: "s3",
  PRINTS: "prints",
  BACKUP: "backup",
  OLD: "old",
  SYSTEM_TASKS: "system-tasks",
} as const

export const energyLabel = {
  AAAAAA: "A+++++",
  AAAAA: "A++++",
  AAAA: "A+++",
  AAA: "A++",
  AA: "A+",
  A: "A",
  B: "B",
  C: "C",
  D: "D",
  E: "E",
  F: "F",
  G: "G",
  Z: "Z",
} as const

export const faqSection = {
  RENTAL: "rental",
  GENERAL: "general",
  CANCELLATIONS: "cancellations",
  FINANCIAL: "financial",
  DISRUPTIONS: "disruptions",
} as const

export const keyLocation = {
  A: "a",
  B: "b",
  C: "c",
} as const

export const keySubjectType = {
  UNIT: "unit",
  COMPLEX: "complex",
} as const

export const lettermintEvent = {
  MESSAGE_CREATED: "message.created",
  MESSAGE_SENT: "message.sent",
  MESSAGE_DELIVERED: "message.delivered",
  MESSAGE_AUTO_REPLIED: "message.auto_replied",
  MESSAGE_HARD_BOUNCED: "message.hard_bounced",
  MESSAGE_SOFT_BOUNCED: "message.soft_bounced",
  MESSAGE_SPAM_COMPLAINT: "message.spam_complaint",
  MESSAGE_FAILED: "message.failed",
  MESSAGE_SUPPRESSED: "message.suppressed",
  MESSAGE_POLICY_REJECTED: "message.policy_rejected",
  MESSAGE_UNSUBSCRIBED: "message.unsubscribed",
  MESSAGE_OPENED: "message.opened",
  MESSAGE_CLICKED: "message.clicked",
  MESSAGE_INBOUND: "message.inbound",
  SUPPRESSION_ADDED: "suppression.added",
  SUPPRESSION_REMOVED: "suppression.removed",
  WEBHOOK_TEST: "webhook.test",
} as const

export const lettermintMessageStatus = {
  SCHEDULED: "scheduled",
  PENDING: "pending",
  QUEUED: "queued",
  PROCESSED: "processed",
  DELIVERED: "delivered",
  OPENED: "opened",
  CLICKED: "clicked",
  SOFT_BOUNCED: "soft_bounced",
  HARD_BOUNCED: "hard_bounced",
  SPAM_COMPLAINT: "spam_complaint",
  SUPPRESSED: "suppressed",
  UNSUBSCRIBED: "unsubscribed",
  FAILED: "failed",
  BLOCKED: "blocked",
  POLICY_REJECTED: "policy_rejected",
  CANCELED: "canceled",
} as const

export const mailTag = {
  MATCHMAIL: "matchmail",
  MATCHMAIL_WEEKLY: "matchmail-weekly",
  NEWSLETTER: "newsletter",
} as const

export const mailer = {
  LETTERMINT: "lettermint",
  BROADCAST: "broadcast",
  NEWSLETTER: "newsletter",
  HBM: "hbm",
  CAMPUS: "campus",
} as const

export const neighborhood = {
  AMBY: "amby",
  BEATRIXHAVEN: "beatrixhaven",
  BELFORT: "belfort",
  BELVEDERE: "belvedere",
  BIESLAND: "biesland",
  BINNENSTAD: "binnenstad",
  BORGHAREN: "borgharen",
  BOSCHPOORT: "boschpoort",
  BOSCHSTRAATKWARTIER: "boschstraatkwartier",
  BOSSCHERVELD: "bosscherveld",
  BRUSSELSEPOORT: "brusselsepoort",
  CABERG: "caberg",
  CAMPAGNE: "campagne",
  DAALHOF: "daalhof",
  DE_HEEG: "de-heeg",
  DOUSBERG_HAZENDANS: "dousberg-hazendans",
  FRONTENKWARTIER: "frontenkwartier",
  HEER: "heer",
  HEUGEM: "heugem",
  HEUGEMERVELD: "heugemerveld",
  ITTEREN: "itteren",
  JEKERDAL: "jekerdal",
  JEKERKWARTIER: "jekerkwartier",
  KOMMELKWARTIER: "kommelkwartier",
  LANAKERVELD: "lanakerveld",
  LIMMEL: "limmel",
  MALBERG: "malberg",
  MALPERTUIS: "malpertuis",
  MARIABERG: "mariaberg",
  MEERSSENHOVEN: "meerssenhoven",
  NAZARETH: "nazareth",
  OUD_CABERG: "oud-caberg",
  POTTENBERG: "pottenberg",
  RANDWYCK: "randwyck",
  SCHARN: "scharn",
  SINT_MAARTENSPOORT: "sint-maartenspoort",
  SINT_PIETER: "sint-pieter",
  STATENKWARTIER: "statenkwartier",
  VILLAPARK: "villapark",
  VROENDAAL: "vroendaal",
  WITTEVROUWENVELD: "wittevrouwenveld",
  WOLDER: "wolder",
  WYCK: "wyck",
  WYCKERPOORT: "wyckerpoort",
} as const

export const newsletter = {
  STUDENTCAMPUS: "student-campus",
  SCHEG: "scheg",
} as const

export const paymentStatus = {
  OPEN: "open",
  PENDING: "pending",
  AUTHORIZED: "authorized",
  CANCELED: "canceled",
  EXPIRED: "expired",
  PAID: "paid",
  FAILED: "failed",
  REFUNDED: "refunded",
} as const

export const placeType = {
  LANDMARK: "landmark",
  PARK: "park",
  HOSPITAL: "hospital",
  UNIVERSITY: "university",
  SUPERMARKET: "supermarket",
} as const

export const queue = {
  DEFAULT: "default",
  FILE_PROCESSING: "file-processing",
  MAIL_BROADCAST: "mail-broadcast",
  ERRORS: "errors",
} as const

export const registrationRoundApplicationStatus = {
  PENDING: "pending",
  SELECTED: "selected",
  SELECTED_VIEW_FIRST: "selected-view-first",
  WITHDRAWN: "withdrawn",
  WITHDRAWN_AFTER_SELECTION: "withdrawn-after-selection",
  SIGNED: "signed",
  REJECTED: "rejected",
  REJECTED_WITHOUT_EMAIL: "rejected-without-email",
} as const

export const registrationRoundDuration = {
  ONE_DAY: "1-day",
  TWO_DAYS: "2-days",
  THREE_DAYS: "3-days",
  FOUR_DAYS: "4-days",
  FIVE_DAYS: "5-days",
  UNLIMITED: "unlimited",
} as const

export const registrationRoundStatus = {
  PENDING: "pending",
  ACTIVE: "active",
  UNDER_OPTION: "under-option",
  COMPLETED: "completed",
  CANCELLED: "cancelled",
} as const

export const searchSortOption = {
  RENT_DESC: "-rent",
  RENT_ASC: "rent",
  LATEST: "latest",
} as const

export const searchUnitCapacity = {
  ONE: "one",
  COUPLE: "couple",
  TWO: "two",
  THREE_PLUS: "three-plus",
} as const

export const searchUnitGroup = {
  ALL: "all",
  ROOM: "room",
  APARTMENT_HOUSE: "apartment-house",
  STUDENT_CAMPUS: "student-campus",
  PARKING: "parking",
  COMMERCIAL: "commercial",
  SCHEG: "scheg",
  SCHEG_STUDENT: "scheg-student",
} as const

export const servicesSection = {
  RENT: "rent",
  RENT_OUT: "rent-out",
  MANAGEMENT: "management",
} as const

export const studyInstitution = {
  FONTYS_HOGESCHOOL: "fontys-hogeschool",
  HOGESCHOOL_ZUYD: "hogeschool-zuyd",
  JAN_VAN_EYCK_ACADEMY: "jan-van-eyck-academy",
  VISTA_COLLEGE: "vista-college",
  MAASTRICHT_UNIVERSITY: "maastricht-university",
  OPEN_UNIVERSITEIT: "open-universiteit",
} as const

export const subscriberAccountType = {
  BASIC: "basic",
  PREMIUM: "premium",
} as const

export const subscriberDuplicateConfidence = {
  CERTAIN: "certain",
  PROBABLE: "probable",
  POSSIBLE: "possible",
} as const

export const subscriberDuplicateSignal = {
  NAME_BIRTHDAY: "name_birthday",
  SIMILAR_NAME_BIRTHDAY_ADDRESS: "similar_name_birthday_address",
  BIRTHDAY_ADDRESS: "birthday_address",
  PHONE_NAME: "phone_name",
  BACKUP_CONTACT_NAME: "backup_contact_name",
  SURNAME_BIRTHDAY: "surname_birthday",
  SHARED_IP: "shared_ip",
} as const

export const subscriberDuplicateVerdict = {
  SamePerson: "same_person",
  DifferentPeople: "different_people",
} as const

export const subscriberGender = {
  MALE: "male",
  FEMALE: "female",
  OTHER: "other",
} as const

export const subscriberIncomeCategory = {
  SCHOLARSHIP: "scholarship",
  SALARY: "salary",
  PARENTS: "parents",
  OTHER: "other",
} as const

export const subscriberRating = {
  THUMBS_UP: "thumbs-up",
  THUMBS_DOWN: "thumbs-down",
} as const

export const subscriberRelation = {
  PARENT: "parent",
  GUARDIAN: "guardian",
  FAMILY: "family",
  SIBLING: "sibling",
  PARTNER: "partner",
  FRIEND: "friend",
  FELLOW_STUDENT: "fellow-student",
  EMPLOYER: "employer",
  COLLEAGUE: "colleague",
  OTHER: "other",
} as const

export const subscriberSchegCandidateType = {
  WORKING_FULLTIME: "working-fulltime",
  WORKING_PARTTIME: "working-parttime",
  PHD_RESEARCHER: "phd-researcher",
  STUDENT: "student",
  OTHER: "other",
} as const

export const subscriberType = {
  STUDENT: "student",
  NONSTUDENT: "nonstudent",
} as const

export const supportedLocale = {
  NL: "nl",
  EN: "en",
} as const

export const systemTaskStatus = {
  PENDING: "pending",
  PROCESSING: "processing",
  COMPLETED: "completed",
  FAILED: "failed",
} as const

export const unitOfferViewingViewingType = {
  PHYSICAL: "physical",
  DIGITAL: "digital",
} as const

export const unitOfferCondition = {
  NEW_MAASLAND: "new-maasland",
  CONTRACT_HBM: "contract-hbm",
  GROUP_HBM: "group-hbm",
  ON_HOLD: "on-hold",
  SUBLETTING: "subletting",
} as const

export const unitOfferContractDuration = {
  FIXED_TERM: "fixed-term",
  INDEFINITE_MIN_1_YEAR: "indefinite-min-1-year",
  INDEFINITE_MIN_DATE: "indefinite-min-date",
  SHORT_STAY_MIN_DATE: "short-stay-min-date",
} as const

export const unitOfferDocumentType = {
  CONTRACT: "contract",
  HANDOVER_END: "handover-end",
  HANDOVER_START: "handover-start",
  KEYS: "keys",
} as const

export const unitOfferInterior = {
  EMPTY: "empty",
  FURNISHED_PARTIALLY: "furnished-partially",
  FURNISHED: "furnished",
  UPHOLSTERED: "upholstered",
} as const

export const unitOfferNoticePeriod = {
  MONTHS_1: "months-1",
  MONTHS_3: "months-3",
  NOT_APPLICABLE: "na",
} as const

export const unitOfferRentalStatus = {
  FOR_RENT: "for-rent",
  NOT_FOR_RENT: "not-for-rent",
  FUTURE_RENTAL: "future-rental",
  PUBLISHED: "published",
} as const

export const unitOfferStatus = {
  DRAFT: "draft",
  PUBLISHED: "published",
  COMPLETED: "completed",
  ARCHIVED: "archived",
} as const

export const unitAttachmentCategory = {
  FLOOR_PLAN: "floor-plan",
  BROCHURE: "brochure",
  CADASTRAL_MAP: "cadastral-map",
  MONUMENT_REPORT: "monument-report",
  OTHER: "other",
} as const

export const unitAudience = {
  NONE: 0,
  STUDENTS_ONLY: 1,
  PREF_WORKING: 2,
  STUDENT_PHD_EXPAT: 4,
  SCHEG_NON_STUDENT: 8,
  SCHEG_STUDENT: 16,
} as const

export const unitCampusType = {
  WAUWHAUS: "wauwhaus",
  THINKTANK: "thinktank",
  ED: "ed",
  SCHEG: "scheg",
} as const

export const unitCapacity = {
  ONE: "one",
  ONE_OR_COUPLE: "one-or-couple",
  MAX_TWO: "max-two",
  MAX_THREE: "max-three",
  MAX_FOUR: "max-four",
  MAX_FIVE: "max-five",
  MAX_SIX: "max-six",
} as const

export const unitCategory = {
  PARKING: "parking",
  COMMERCIAL: "commercial",
  DOMESTIC: "domestic",
} as const

export const unitHeatingSystem = {
  SHARED_CENTRAL: "shared-central",
  HR_COMBI: "hr-combi",
  HR: "hr",
  VR: "vr",
  NORMAL: "normal",
} as const

export const unitKitchenType = {
  KITCHENETTE: "kitchenette",
  HALFOPEN: "halfopen",
  OPEN: "open",
  LUXURY: "luxury",
  SEPARATE: "separate",
} as const

export const unitLocationDepth = {
  FRONT: "front",
  MIDDLE: "middle",
  BACK: "back",
  VESTIBULE: "vestibule",
  ANNEX: "annex",
} as const

export const unitLocationFloor = {
  F1: "f1",
  F2: "f2",
  F3: "f3",
  F4: "f4",
  F5: "f5",
  F6: "f6",
  F7: "f7",
  F8: "f8",
  GROUND: "ground",
  SOUTERRAIN: "souterrain",
} as const

export const unitLocationSide = {
  LEFT: "left",
  MIDDLE: "middle",
  RIGHT: "right",
} as const

export const unitUnitType = {
  APARTMENT: "apartment",
  HOUSE: "house",
  ROOM: "room",
  STUDIO: "studio",
  GROUP: "group",
  STUDENT_CAMPUS: "student-campus",
  SCHEG_APARTMENT: "scheg-apartment",
  SCHEG_STUDIO: "scheg-studio",
  SCHEG_STUDIO_STUDENT: "scheg-studio-student",
} as const

export const unitUnitZoningType = {
  OFFICE: "office",
  STORE: "store",
  CATERING: "catering",
  OTHER: "other",
} as const
